import axios from "axios";
import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";


const DIVES_API_URL = "/api/dives";

const useDivesiteStats = (divesiteId) => {
  const [statsWithComments, setStatsWithComments] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();


  useEffect(() => {
    const loadStats = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await currentUser.getIdToken();
        const response = await axios.get(
          `${DIVES_API_URL}/${divesiteId}/stats`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStatsWithComments(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (divesiteId) {
      loadStats();
    }
  }, [divesiteId]);

  return { statsWithComments, loading, error };
};

export default useDivesiteStats;